import Select, { components } from 'react-select'
import { UnitTypeCategory } from '@wove/common/units'
import { useState } from 'react'
import { useUnitTypes } from '@wove/api/lib/hooks/useUnitTypes'

interface UnitTypeSelectProps {
  value: string
  onChange: (value: string) => void
  category: UnitTypeCategory
  isDisabled?: boolean
  placeholder?: string
}

export const UnitTypeSelect = ({
  value,
  onChange,
  category,
  isDisabled = false,
  placeholder = 'Select a unit type',
}: UnitTypeSelectProps) => {
  const [isHovered, setIsHovered] = useState(false)
  const { data, isLoading } = useUnitTypes()
  const options =
    data?.unitTypes?.[category]?.map(unitType => ({
      label: unitType.name,
      value: unitType.code,
    })) || []

  const selectedOption = options?.find(option => option.value === value) || null

  // Custom SingleValue component that shows a tooltip
  const SingleValue = (props: any) => (
    <div title={props.data.label}>
      <components.SingleValue {...props} />
    </div>
  )

  return (
    <div onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)} style={{ width: '100%' }}>
      <Select
        options={options}
        value={selectedOption}
        onChange={selected => onChange(selected ? selected.value : '')}
        isLoading={isLoading}
        isDisabled={isDisabled}
        placeholder={placeholder}
        className="w-full"
        classNamePrefix="unit-type-select"
        components={{ SingleValue }}
        styles={{
          control: (base, state) => ({
            ...base,
            minHeight: '32px',
            width: '100%',
          }),
          valueContainer: (base, state) => ({
            ...base,
            padding: '0px 8px',
            paddingRight: state.selectProps.menuIsOpen || isHovered ? '8px' : '4px',
          }),
          singleValue: base => ({
            ...base,
            fontSize: '0.875rem',
          }),
          input: base => ({
            ...base,
            margin: 0,
            padding: 0,
          }),
          indicatorsContainer: (base, state) => ({
            ...base,
            width: state.selectProps.menuIsOpen || isHovered ? 'auto' : '0px',
            opacity: state.selectProps.menuIsOpen || isHovered ? 1 : 0,
            transition: 'width 0.2s, opacity 0.2s',
            overflow: 'hidden',
          }),
          dropdownIndicator: base => ({
            ...base,
            padding: '4px',
          }),
          indicatorSeparator: () => ({
            display: 'none',
          }),
          menu: base => ({
            ...base,
            minWidth: '120px',
          }),
        }}
      />
    </div>
  )
}
